module.exports = __webpack_public_path__ + "img/hr-rock-huge-12.3309ab84.png";